import { render, staticRenderFns } from "./RuleDialog.vue?vue&type=template&id=bc8d4a8c&scoped=true&"
import script from "./RuleDialog.vue?vue&type=script&lang=js&"
export * from "./RuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8d4a8c",
  null
  
)

export default component.exports